import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useEffect, useState } from "react";
import Axios from "axios";
import { Table, Modal, Form } from "react-bootstrap";
import swal from "sweetalert";
import Button from "react-bootstrap/Button";
import "./settlement.css";
import Spinner from "react-bootstrap/Spinner";
import logUserActivity from "../utils/logUserActivity";

import { CSVLink } from "react-csv";


const StockCategory = () => {
  const [data, setData] = useState([]);
  const [shelf, setShelf] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [totalStock, setTotalStock] = useState(0);
  const [categoryStock, setCategoryStock] = useState(0);
  const [loadingState, setLoadingState] = useState({});
  const [showPopover, setShowPopover] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryInputs, setCategoryInputs] = useState({});
  const [formData, setFormData] = React.useState({
    avgSettlementAmount: "",
    flipkartTQuantity: "",
    amazonTQuantity: "",
    flipkartWQuantity: "",
    amazonWQuantity: "",
  });

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`)
      .then((response) => {
        const updatedData = response.data.map((item) => ({
          ...item,
          category: "",
        }));
        setData(updatedData);
      })
      .catch((error) => {
        console.error("Error fetching book list:", error);
      });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getCreateshelf`)
      .then((response) => {
        const shelfData = response.data.reduce((acc, item) => {
          const existingItem = acc.find((x) => x.sku === item.sku);
          if (existingItem) {
            existingItem.presentquantity += item.presentquantity;
            existingItem.shelfData.push({
              shelfno: item.shelfno,
              presentquantity: item.presentquantity,
            });
          } else {
            acc.push({
              sku: item.sku,
              presentquantity: item.presentquantity,
              shelfData: [
                {
                  shelfno: item.shelfno,
                  presentquantity: item.presentquantity,
                },
              ],
            });
          }
          return acc;
        }, []);
        setShelf(shelfData);
        const total = shelfData.reduce(
          (sum, item) => sum + item.presentquantity,
          0
        );
        setTotalStock(total);
      })
      .catch((error) => {
        console.error("Error fetching shelf data:", error);
      });
  }, []);

  useEffect(() => {
    const filteredShelf =
      selectedCategory === "All"
        ? shelf
        : shelf.filter((item) => {
            const dataItem = data.find((d) => d.sku === item.sku);
            if (!dataItem) return false;

            const category =
              dataItem.bookCategory >= 300
                ? "A"
                : dataItem.bookCategory >= 150
                ? "B"
                : dataItem.bookCategory >= 15
                ? "C"
                : "Scrap";

            return category === selectedCategory;
          });

    const categoryTotal = filteredShelf.reduce(
      (sum, item) => sum + item.presentquantity,
      0
    );

    setCategoryStock(categoryTotal);
  }, [selectedCategory, shelf, data]);

  const handleSave = async (id) => {
    const newCategory = categoryInputs[id];
    if (!newCategory) {
      swal("Error", "Please enter Input before saving.", "error");
      return;
    }

    setLoadingState((prevState) => ({ ...prevState, [id]: true }));

    const currentItem = data.find((item) => item._id === id);
    const oldCategory = currentItem?.bookCategory;

    try {
      await Axios.put(`${INVENTORY_API_BASE_URL}/axis/${id}`, {
        bookCategory: newCategory,
      });

      setData((prevData) =>
        prevData.map((item) =>
          item._id === id ? { ...item, bookCategory: newCategory } : item
        )
      );

      await logUserActivity("SAVE_BOOK_CATEGORY", {
        bookId: id,
        oldCategory,
        newCategory,
      });

      setCategoryInputs((prevInputs) => {
        const newInputs = { ...prevInputs };
        delete newInputs[id];
        return newInputs;
      });
    } catch (error) {
      console.error("Error saving category:", error);
      swal("Error", "Failed to save the category. Please try again.", "error");
    } finally {
      setLoadingState((prevState) => ({ ...prevState, [id]: false }));
    }
  };

  const getShelfDetails = (sku) => {
    const shelfItem = shelf.find((item) => item.sku === sku);
    if (shelfItem) {
      const tooltip = shelfItem.shelfData
        .map((s) => `Shelf ${s.shelfno}: ${s.presentquantity} items`)
        .join(", ");
      return { quantity: shelfItem.presentquantity, tooltip };
    }
    return { quantity: 0, tooltip: "No data available" };
  };

  const calculateValue = (mrp, stock, bookCategory, weight = 0) => {
    if (!mrp || !stock) return 0;

    if (bookCategory >= 300) {
      return 0.41 * mrp * stock; 
    } else if (bookCategory >= 150) {
      return 0.25 * mrp * stock; 
    } else if (bookCategory >= 15) {
      return 0.1 * mrp * stock; 
    } else {
      return (weight / 1000) * 15 * stock; 
    }
  };

  const totals = data.reduce(
    (acc, item) => {
      const { quantity } = getShelfDetails(item.sku);
      const value = calculateValue(
        item.mrp,
        quantity,
        item.bookCategory,
        item.weight
      );

      const category =
        item.bookCategory >= 300
          ? "A"
          : item.bookCategory >= 150
          ? "B"
          : item.bookCategory >= 15
          ? "C"
          : "Scrap";

      if (category === "A") acc.A += value;
      if (category === "B") acc.B += value;
      if (category === "C") acc.C += value;
      if (category === "Scrap") acc.Scrap += value;

      return acc;
    },
    { A: 0, B: 0, C: 0, Scrap: 0 }
  );

  const totalSum = totals.A + totals.B + totals.C + totals.Scrap;

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchSettlementData = async () => {
      try {
        const response = await Axios.get(
          `${INVENTORY_API_BASE_URL}/get-settlement`
        );
        if (response.status === 200) {
          setFormData(response.data.settlement);
        } else {
        }
      } catch (error) {
        console.error("Error fetching settlement data:", error);
      }
    };

    fetchSettlementData();
  }, []);

  const handleCategoryInputChange = (id, value) => {
    setCategoryInputs((prevInputs) => ({
      ...prevInputs,
      [id]: value,
    }));
  };

  const handleFormSubmit = async () => {
    try {
      const filteredFormData = Object.fromEntries(
        Object.entries(formData).filter(([_, value]) => value !== "")
      );

      if (Object.keys(filteredFormData).length === 0) {
        alert("No changes to save.");
        return;
      }

      const oldResponse = await Axios.get(
        `${INVENTORY_API_BASE_URL}/get-settlement`
      );
      const oldData = oldResponse?.data?.settlement || {};

      const response = await Axios.put(
        `${INVENTORY_API_BASE_URL}/save-settlement`,
        filteredFormData
      );

      if (response.status === 200) {
        await logUserActivity("SAVE_SETTLEMENT_FORM", {
          oldData,
          newData: filteredFormData,
        });

        alert("Settlement data saved successfully!");
        window.location.reload();
      } else {
        alert("Failed to save data. Please try again.");
      }
    } catch (error) {
      console.error("Error saving settlement data:", error);
      alert("Failed to save data. Please check your network or server.");
    }
  };

  const filteredData = data.filter((item) => {
    const category =
      item.bookCategory >= 300
        ? "A"
        : item.bookCategory >= 150
        ? "B"
        : item.bookCategory >= 15
        ? "C"
        : "Scrap";

    const matchesCategory =
      selectedCategory === "All" || category === selectedCategory;

    const matchesSearch =
      item.sku?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.title?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const filteredCsvData = data
    .filter((item) => {
      if (selectedCategory === "All") return true;
      let category;
      if (item.bookCategory >= 300) {
        category = "A";
      } else if (item.bookCategory >= 150) {
        category = "B";
      } else if (item.bookCategory >= 15) {
        category = "C";
      } else {
        category = "Scrap";
      }
      return category === selectedCategory;
    })
    .map((item, index) => {
      const { quantity } = getShelfDetails(item.sku);
      return {
        SR_NO: index + 1,
        SKU: item.sku,
        Title: item.title,
        Medium: item.Medium,
        Edition: item.edition,
        Weight: item.weight,
        MRP: item.mrp,
        BookCategory: item.bookCategory || "N/A",
        Stock: quantity,
        Value: calculateValue(
          item.mrp,
          quantity,
          item.bookCategory,
          item.weight
        ).toFixed(2),
        Category:
          item.bookCategory >= 300
            ? "A"
            : item.bookCategory >= 150
            ? "B"
            : item.bookCategory >= 15
            ? "C"
            : "Scrap",
      };
    });

  const csvHeaders = [
    { label: "SR. NO", key: "SR_NO" },
    { label: "SKU", key: "SKU" },
    { label: "Title", key: "Title" },
    { label: "Medium", key: "Medium" },
    { label: "Edition", key: "Edition" },
    { label: "Weight (Gram)", key: "Weight" },
    { label: "MRP", key: "MRP" },
    { label: "Stock", key: "Stock" },
    { label: "Total Sales", key: "BookCategory" },
    { label: "Category", key: "Category" },

    { label: "Value", key: "Value" },
  ];

  return (
    <main className="settlementcontainer settlement-page">
      <header className="settlement-hero">
        <div className="settlement-hero__copy">
          <p className="settlement-eyebrow">Finance operations · Inventory reconciliation</p>
          <h1>Settlement</h1>
          <p>Review warehouse stock value, marketplace quantities, and SKU-level settlement details.</p>
        </div>
        <button
          type="button"
          className="settlement-form-trigger"
          onClick={() => setShowPopover(true)}
        >
          <span className="settlement-form-trigger__icon" aria-hidden="true">SET</span>
          <span>
            <strong>Settlement inputs</strong>
            <small>Update marketplace totals</small>
          </span>
          <span className="settlement-form-trigger__arrow" aria-hidden="true">→</span>
        </button>
      </header>

      <section className="settlement-kpis" aria-label="Settlement overview">
        <article className="settlement-kpi">
          <span className="settlement-kpi__icon" aria-hidden="true">STK</span>
          <span className="settlement-kpi__copy">
            <span>Warehouse stock</span>
            <strong>{totalStock.toLocaleString()}</strong>
            <small>Units across all shelves</small>
          </span>
        </article>
        <article className="settlement-kpi settlement-kpi--value">
          <span className="settlement-kpi__icon" aria-hidden="true">₹</span>
          <span className="settlement-kpi__copy">
            <span>Stock valuation</span>
            <strong>₹{totalSum.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
            <small>Based on category and stock</small>
          </span>
        </article>
        <article className="settlement-kpi settlement-kpi--average">
          <span className="settlement-kpi__icon" aria-hidden="true">AVG</span>
          <span className="settlement-kpi__copy">
            <span>Average settlement amount</span>
            <strong>₹{Number(formData.avgSettlementAmount || 0).toLocaleString("en-IN")}</strong>
            <small>Marketplace rate input</small>
          </span>
        </article>
      </section>

      <Modal
        show={showPopover}
        onHide={() => setShowPopover(false)}
        centered
        backdrop="static"
        keyboard={false}
        className="settlement-modal"
        aria-labelledby="settlement-modal-title"
      >
        <Modal.Header className="settlement-modal__header">
          <div>
            <p className="settlement-eyebrow">Marketplace configuration</p>
            <Modal.Title id="settlement-modal-title">Settlement inputs</Modal.Title>
          </div>
          <button
            type="button"
            className="settlement-modal__back"
            onClick={() => setShowPopover(false)}
          >
            ← Back
          </button>
        </Modal.Header>
        <Modal.Body className="settlement-modal__body">
          <p className="settlement-modal__description">
            Enter the settlement amount and marketplace quantities used in the summary.
          </p>
          <Form className="settlement-form">
            {[
              { label: "Average settlement amount", name: "avgSettlementAmount" },
              { label: "Flipkart (T) quantity", name: "flipkartTQuantity" },
              { label: "Amazon (T) quantity", name: "amazonTQuantity" },
              { label: "Flipkart (W) quantity", name: "flipkartWQuantity" },
              { label: "Amazon (W) quantity", name: "amazonWQuantity" },
            ].map(({ label, name }) => (
              <Form.Group key={name} className="settlement-form__field">
                <Form.Label htmlFor={name}>{label}</Form.Label>
                <Form.Control
                  id={name}
                  type="number"
                  name={name}
                  value={formData[name]}
                  onChange={handleFormChange}
                />
              </Form.Group>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer className="settlement-modal__footer">
          <Button
            type="button"
            className="settlement-button settlement-button--secondary"
            onClick={() => setShowPopover(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="settlement-button settlement-button--primary"
            onClick={handleFormSubmit}
          >
            Save settlement inputs
          </Button>
        </Modal.Footer>
      </Modal>

      <section className="settlement-panel" aria-labelledby="settlement-overview-heading">
        <div className="settlement-panel__heading">
          <div>
            <p className="settlement-eyebrow">Reconciliation</p>
            <h2 id="settlement-overview-heading">Stock and marketplace overview</h2>
            <p>Category counts, stock quantities, and calculated values in one view.</p>
          </div>
          <span className="settlement-panel__badge">Live summary</span>
        </div>
        <div className="settlement-table-scroll">
          <Table className="setttable settlement-summary-table">
            <thead>
              <tr>
                <th scope="col">Measure</th>
                <th scope="col">Category A</th>
                <th scope="col">Category B</th>
                <th scope="col">Category C</th>
                <th scope="col">Scrap</th>
                <th scope="col">Total (P.W)</th>
                <th scope="col">Flipkart (T)</th>
                <th scope="col">Amazon (T)</th>
                <th scope="col">Flipkart (W)</th>
                <th scope="col">Amazon (W)</th>
                <th scope="col">Flipkart total</th>
                <th scope="col">Amazon total</th>
                <th scope="col">Total stocks (P.W + A + F)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">SKU count</th>
                <td>
                  {data.filter((item) => {
                    const category =
                      item.bookCategory >= 300
                        ? "A"
                        : item.bookCategory >= 150
                        ? "B"
                        : item.bookCategory >= 15
                        ? "C"
                        : "Scrap";
                    return category === "A";
                  }).length}
                </td>
                <td>
                  {data.filter((item) => {
                    const category =
                      item.bookCategory >= 300
                        ? "A"
                        : item.bookCategory >= 150
                        ? "B"
                        : item.bookCategory >= 15
                        ? "C"
                        : "Scrap";
                    return category === "B";
                  }).length}
                </td>
                <td>
                  {data.filter((item) => {
                    const category =
                      item.bookCategory >= 300
                        ? "A"
                        : item.bookCategory >= 150
                        ? "B"
                        : item.bookCategory >= 15
                        ? "C"
                        : "Scrap";
                    return category === "C";
                  }).length}
                </td>
                <td>
                  {data.filter((item) => {
                    const category =
                      item.bookCategory >= 300
                        ? "A"
                        : item.bookCategory >= 150
                        ? "B"
                        : item.bookCategory >= 15
                        ? "C"
                        : "Scrap";
                    return category === "Scrap";
                  }).length}
                </td>
                <td>
                  {data.filter((item) => {
                    const category =
                      item.bookCategory >= 300
                        ? "A"
                        : item.bookCategory >= 150
                        ? "B"
                        : item.bookCategory >= 15
                        ? "C"
                        : "Scrap";
                    return ["A", "B", "C", "Scrap"].includes(category);
                  }).length}
                </td>
                <td className="settlement-not-applicable">—</td>
                <td className="settlement-not-applicable">—</td>
                <td className="settlement-not-applicable">—</td>
                <td className="settlement-not-applicable">—</td>
                <td className="settlement-not-applicable">—</td>
                <td className="settlement-not-applicable">—</td>
                <td className="settlement-not-applicable">—</td>
              </tr>
              <tr>
                <th scope="row">Quantity</th>
                <td>
                  {shelf
                    .filter((item) => {
                      const dataItem = data.find((d) => d.sku === item.sku);
                      if (!dataItem) return false;
                      const category =
                        dataItem.bookCategory >= 300
                          ? "A"
                          : dataItem.bookCategory >= 150
                          ? "B"
                          : dataItem.bookCategory >= 15
                          ? "C"
                          : "Scrap";
                      return category === "A";
                    })
                    .reduce((sum, item) => sum + item.presentquantity, 0)}
                </td>
                <td>
                  {shelf
                    .filter((item) => {
                      const dataItem = data.find((d) => d.sku === item.sku);
                      if (!dataItem) return false;
                      const category =
                        dataItem.bookCategory >= 300
                          ? "A"
                          : dataItem.bookCategory >= 150
                          ? "B"
                          : dataItem.bookCategory >= 15
                          ? "C"
                          : "Scrap";
                      return category === "B";
                    })
                    .reduce((sum, item) => sum + item.presentquantity, 0)}
                </td>
                <td>
                  {shelf
                    .filter((item) => {
                      const dataItem = data.find((d) => d.sku === item.sku);
                      if (!dataItem) return false;
                      const category =
                        dataItem.bookCategory >= 300
                          ? "A"
                          : dataItem.bookCategory >= 150
                          ? "B"
                          : dataItem.bookCategory >= 15
                          ? "C"
                          : "Scrap";
                      return category === "C";
                    })
                    .reduce((sum, item) => sum + item.presentquantity, 0)}
                </td>
                <td>
                  {shelf
                    .filter((item) => {
                      const dataItem = data.find((d) => d.sku === item.sku);
                      if (!dataItem) return false;
                      const category =
                        dataItem.bookCategory >= 300
                          ? "A"
                          : dataItem.bookCategory >= 150
                          ? "B"
                          : dataItem.bookCategory >= 15
                          ? "C"
                          : "Scrap";
                      return category === "Scrap";
                    })
                    .reduce((sum, item) => sum + item.presentquantity, 0)}
                </td>
                <td>{totalStock}</td>
                <td>{formData.flipkartTQuantity || 0}</td>
                <td>{formData.amazonTQuantity || 0}</td>
                <td>{formData.flipkartWQuantity || 0}</td>
                <td>{formData.amazonWQuantity || 0}</td>
                <td>{(formData.flipkartTQuantity || 0) + (formData.flipkartWQuantity || 0)}</td>
                <td>{(formData.amazonTQuantity || 0) + (formData.amazonWQuantity || 0)}</td>
                <td>
                  {totalStock +
                    ((formData.flipkartTQuantity || 0) + (formData.flipkartWQuantity || 0)) +
                    ((formData.amazonTQuantity || 0) + (formData.amazonWQuantity || 0))}
                </td>
              </tr>
              <tr>
                <th scope="row">Value (Rs)</th>
                <td>{totals.A.toFixed(2)}</td>
                <td>{totals.B.toFixed(2)}</td>
                <td>{totals.C.toFixed(2)}</td>
                <td>{totals.Scrap.toFixed(2)}</td>
                <td>{totalSum.toFixed(2)}</td>
                <td>{(formData.avgSettlementAmount || 0) * (formData.flipkartTQuantity || 0)}</td>
                <td>{(formData.avgSettlementAmount || 0) * (formData.amazonTQuantity || 0)}</td>
                <td>{(formData.avgSettlementAmount || 0) * (formData.flipkartWQuantity || 0)}</td>
                <td>{(formData.avgSettlementAmount || 0) * (formData.amazonWQuantity || 0)}</td>
                <td>
                  {(formData.avgSettlementAmount || 0) * (formData.flipkartTQuantity || 0) +
                    (formData.avgSettlementAmount || 0) * (formData.flipkartWQuantity || 0)}
                </td>
                <td>
                  {(formData.avgSettlementAmount || 0) * (formData.amazonTQuantity || 0) +
                    (formData.avgSettlementAmount || 0) * (formData.amazonWQuantity || 0)}
                </td>
                <td>
                  {(
                    parseFloat(totalSum) +
                    ((formData.avgSettlementAmount || 0) * (formData.flipkartTQuantity || 0) +
                      (formData.avgSettlementAmount || 0) * (formData.flipkartWQuantity || 0)) +
                    ((formData.avgSettlementAmount || 0) * (formData.amazonTQuantity || 0) +
                      (formData.avgSettlementAmount || 0) * (formData.amazonWQuantity || 0))
                  ).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </section>

      <section className="settlement-panel settlement-stock-panel" aria-labelledby="stock-detail-heading">
        <div className="settlement-panel__heading">
          <div>
            <p className="settlement-eyebrow">Warehouse inventory</p>
            <h2 id="stock-detail-heading">Stock valuation by SKU</h2>
            <p>Search, review, and update the sales quantity used for each book category.</p>
          </div>
          <span className="settlement-panel__badge">
            {filteredData.length.toLocaleString()} matching SKUs
          </span>
        </div>

        <div className="settlement-toolbar">
          <label className="settlement-filter">
            <span>Book category</span>
            <select
              id="categoryFilter"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="All">All categories</option>
              <option value="A">Category A</option>
              <option value="B">Category B</option>
              <option value="C">Category C</option>
              <option value="Scrap">Scrap</option>
            </select>
          </label>
          <label className="settlement-search">
            <span>Search inventory</span>
            <input
              type="text"
              placeholder="Search SKU or title"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </label>
          <div className="settlement-stock-total">
            <span>{selectedCategory === "All" ? "Total warehouse stock" : "Category stock"}</span>
            <strong>{selectedCategory === "All" ? totalStock : categoryStock}</strong>
          </div>
          <CSVLink
            className="settlement-export"
            data={filteredCsvData}
            headers={csvHeaders}
            filename={`stock_data_${selectedCategory}.csv`}
            onMouseOver={(e) => (e.target = "inherit")}
            onMouseOut={(e) => (e.target = "inherit")}
          >
            Export CSV
            <span aria-hidden="true">↓</span>
          </CSVLink>
        </div>

        <div className="settlement-table-scroll settlement-stock-scroll">
          <Table className="setttable settlement-stock-table">
            <thead>
              <tr>
                <th scope="col">SR. NO</th>
                <th scope="col">SKU</th>
                <th scope="col">Stock</th>
                <th scope="col">Title</th>
                <th scope="col">Medium</th>
                <th scope="col">Edition</th>
                <th scope="col">Weight (Gram)</th>
                <th scope="col">MRP</th>
                <th scope="col">Total Sales (F+A+S)</th>
                <th scope="col">Category</th>
                <th scope="col">Last Update</th>
                <th scope="col">Value (Rs)</th>
                <th scope="col">Sales Quantity</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData
                .map((item) => ({
                  ...item,
                  shelfDetails: getShelfDetails(item.sku),
                }))
                .sort((a, b) => b.shelfDetails.quantity - a.shelfDetails.quantity)
                .map((item, index) => {
                  const { quantity, tooltip } = item.shelfDetails;
                  return (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td className="settlement-sku">{item.sku}</td>
                      <td title={tooltip}><span className="settlement-stock-value">{quantity}</span></td>
                      <td className="settlement-book-title" title={item.title}>{item.title}</td>
                      <td>{item.Medium}</td>
                      <td>{item.edition}</td>
                      <td>{item.weight}</td>
                      <td>{item.mrp}</td>
                      <td>{item.bookCategory || "N/A"}</td>
                      <td>
                        {item.bookCategory >= 300
                          ? "A"
                          : item.bookCategory >= 150
                          ? "B"
                          : item.bookCategory >= 15
                          ? "C"
                          : "Scrap"}
                      </td>
                      <td
                        className="settlement-update-date"
                        style={{
                          backgroundColor:
                            item.bookCategoryDate &&
                            new Date() - new Date(item.bookCategoryDate) > 4 * 24 * 60 * 60 * 1000
                              ? "#ffcccc"
                              : "inherit",
                          fontWeight:
                            item.bookCategoryDate &&
                            new Date() - new Date(item.bookCategoryDate) > 4 * 24 * 60 * 60 * 1000
                              ? "600"
                              : "normal",
                        }}
                      >
                        {item.bookCategoryDate
                          ? new Date(item.bookCategoryDate).toLocaleDateString("en-GB")
                          : "N/A"}
                      </td>
                      <td>
                        {calculateValue(
                          item.mrp,
                          quantity,
                          item.bookCategory,
                          item.weight
                        ).toFixed(2)}
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={categoryInputs[item._id] || ""}
                          onChange={(e) => handleCategoryInputChange(item._id, e.target.value)}
                          placeholder="Enter quantity"
                          aria-label={"Sales quantity for " + item.sku}
                        />
                      </td>
                      <td>
                        <Button
                          className="settlement-row-save"
                          onClick={() => handleSave(item._id)}
                          disabled={loadingState[item._id]}
                        >
                          {loadingState[item._id] ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            "Save"
                          )}
                        </Button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </section>
    </main>
  );
};

export default StockCategory;
